import React from 'react';
const links = [{
  label: 'Terms & Conditions',
  href: '#terms'
}, {
  label: 'Privacy Policy',
  href: '#privacy'
}, {
  label: 'Refund Policy',
  href: '#refund'
}, {
  label: 'Contact & Support',
  href: '#contact'
}];
export function SiteFooter() {
  return <footer className="border-t border-brand-ivory/10 bg-brand-charcoal px-5 py-12 text-brand-ivory/70 lg:px-8" data-id="element-162" data-mp="35chjhztuvh0s">
      <div className="mx-auto flex max-w-6xl flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-163" data-mp="3f442wjgckmem">
        <div data-id="element-164" data-mp="3k2ylbkaek8y7">
          <p className="font-body text-[13px] font-semibold uppercase tracking-[0.22em] text-brand-ivory" data-id="element-165" data-mp="3k2feozq7d6zh">
            Barber Instructor Ready™
          </p>
          <p className="mt-1 font-body text-[12px] text-brand-ivory/55" data-id="element-166" data-mp="3o2zanzz1i4k1">by Prof. Kyra</p>
        </div>
        <nav aria-label="Footer" className="flex flex-wrap gap-x-7 gap-y-2 font-body text-[13px]" data-id="element-167" data-mp="3t1iw7z9q1ebv">
          {links.map(link => <a key={link.label} href={link.href} className="underline-offset-4 transition-colors duration-200 ease-out hover:text-brand-ivory hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-ivory/60" data-id="element-168" data-mp="1ypccgc2rhp7y">
              {link.label}
            </a>)}
        </nav>
      </div>
      <p className="mx-auto mt-8 max-w-6xl font-body text-[12px] leading-relaxed text-brand-ivory/45" data-id="element-169" data-mp="3sqrxzpp9xsga">
        © 2026 Barber Instructor Ready™ · Prof. Kyra. This is a digital product — no physical items are
        shipped. It is an independent educational resource system and does not provide a professional
        license, state-approved accreditation or official certification. Secure checkout — payments are
        processed in your local currency.
      </p>
    </footer>;
}